import { Navigate } from "react-router-dom";

import BabyNav from "../../pages/Dashboard/Baby/BabyNav";
import BabyForm from "../../pages/Dashboard/Baby/BabyForm";
import BabyInformation from "../../pages/Dashboard/Baby/BabyInformation";
import BabyList from "../../pages/Dashboard/Baby/BabyList";

const BabyRoutes = {
  path: "/baby",
  element: <BabyNav />,
  children: [
    { index: true, element: <Navigate to="/baby/list" replace /> },
    { path: "/baby/register", element: <BabyForm /> },
    { path: "/baby/list", element: <BabyList /> },
    { path: "/baby/:id", element: <BabyInformation /> },
    { path: "/baby/:id/edit", element: <BabyForm /> },
  ],
};

export default BabyRoutes;
